export default ({vehicle: {svid = ''} = {}} = {}) => svid;
